import shellapi from 'a365-shell-api';

export class Headers implements shellapi.http.IHeaders {
    private _headers: Map<string, string[]> = new Map();
    private _normalizedNames: Map<string, string> = new Map();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(headers?: {[name: string]: any}|null) {
        if (!headers) {
            return;
        }

        if (headers instanceof Headers) {
            headers.forEach((values: string[], name: string) => {
                values.forEach((value: string) => this.append(name, value));
            });
            return;
        }

        Object.keys(headers).forEach((name: string) => {
            const values: string[] = Array.isArray(headers[name]) ? headers[name] : [headers[name]];
            this.delete(name);
            values.forEach((value: string) => this.append(name, value));
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static createHeaders(headers?: {[name: string]: any} | null): shellapi.http.IHeaders {
        return new Headers(headers);
    }

    public append(name: string, value: string): void {
        const values = this.getAll(name);
        if (values === null) {
            this.set(name, value);
        } else {
            values.push(value);
        }
    }

    // eslint-disable-next-line
    public delete(name: string): void {
        const lcName = name.toLowerCase();
        this._normalizedNames.delete(lcName);
        this._headers.delete(lcName);
    }

    public forEach(fn: (values: string[], name: string|undefined, headers: Map<string, string[]>) => void): void {
        this._headers.forEach((values, lcName) => fn(values, this._normalizedNames.get(lcName), this._headers));
    }

    // eslint-disable-next-line
    public get(name: string): string|null {
        const values = this.getAll(name);
        if (values === null) {
            return null;
        }
        return values.length > 0 ? values[0] : null;
    }

    public has(name: string): boolean {
        return this._headers.has(name.toLowerCase());
    }

    public keys(): string[] {
        return Array.from(this._normalizedNames.values());
    }

    // eslint-disable-next-line
    public set(name: string, value: string|string[]): void {
        if (Array.isArray(value)) {
            if (value.length) {
                this._headers.set(name.toLowerCase(), [value.join(',')]);
            }
        } else {
            this._headers.set(name.toLowerCase(), [value]);
        }
        this.mayBeSetNormalizedName(name);
    }

    public getAll(name: string): string[]|null {
        return this.has(name) ? this._headers.get(name.toLowerCase()) || null : null;
    }

    private mayBeSetNormalizedName(name: string): void {
        const lcName = name.toLowerCase();
        if (!this._normalizedNames.has(lcName)) {
            this._normalizedNames.set(lcName, name);
        }
    }
}
